var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C4.85786 16.5 1.5 13.1421 1.5 8.99997C1.5 4.85783 4.85786 1.49997 9 1.49997C13.1421 1.49997 16.5 4.85783 16.5 8.99997C16.5 13.1421 13.1421 16.5 9 16.5ZM9 15C12.3137 15 15 12.3137 15 8.99997C15 5.68626 12.3137 2.99997 9 2.99997C5.68629 2.99997 3 5.68626 3 8.99997C3 12.3137 5.68629 15 9 15ZM9.75 8.99997H12.75V10.5H8.25V5.24997H9.75V8.99997Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline2);
export default __webpack_public_path__ + "static/media/timeline2.28b3666aacddd53676e52ac80abe6e08.svg";
export { ForwardRef as ReactComponent };